import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import {
  createBrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  RouterProvider,
  useLocation,
  useNavigationType,
} from "react-router-dom";
import Estimate from "./components/pages/estimate";
import Buy from "./components/pages/buy";
import Sell from "./components/pages/sell";
import DealService from "./components/pages/dealService";
import Auth from "./components/pages/auth";
import { PATHS } from "./components/shared/constants";
import PersonalAccount from "./components/pages/my";
import "./index.scss";
import {
  SENTRY_DSN,
  SENTRY_ENV,
  SENTRY_RELEASE,
  SENTRY_TRACING,
  YANDEX_METRICS_ACCOUNT,
} from "./lib/constants";
import Facility from "./components/pages/reitFacility";
import TradeIn from "./components/pages/tradeIn";
import { YMInitializer } from "react-yandex-metrika";

Sentry.init({
  enabled: Boolean(Number(SENTRY_TRACING)),
  dsn: SENTRY_DSN,
  environment: SENTRY_ENV,
  release: SENTRY_RELEASE,
  integrations: [
    Sentry.browserProfilingIntegration(),
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.httpClientIntegration(),
    Sentry.browserSessionIntegration(),
    Sentry.replayIntegration({
      maskAllInputs: false,
      maskAllText: false,
      mask: ["password"],
    }),
  ],

  tracesSampleRate: 1.0,

  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouterV6(createBrowserRouter);

export const router = sentryCreateBrowserRouter([
  {
    path: PATHS.base,
    element: (
      <Sentry.ErrorBoundary>
        <App />
      </Sentry.ErrorBoundary>
    ),
    children: [
      { index: true, element: <Estimate /> },
      { path: PATHS.ransom, element: <Estimate modePossibilities="ransom" /> },
      {
        path: PATHS.estimateForRealtor,
        element: <Estimate modePossibilities="forRealtor" />,
      },
      { path: PATHS.buy, element: <Buy /> },
      { path: PATHS.sell, element: <Sell /> },
      { path: PATHS.dealService, element: <DealService /> },
      { path: PATHS.auth, element: <Auth /> },
      { path: PATHS.myPersonal, element: <PersonalAccount /> },
      { path: PATHS.myDeal, element: <PersonalAccount /> },
      { path: PATHS.reitFacility, element: <Facility /> },
      { path: PATHS.tradeIn, element: <TradeIn /> },
      { path: "/*", element: <Estimate /> },
    ],
  },
]);

root.render(
  <React.StrictMode>
    {YANDEX_METRICS_ACCOUNT ? (
      <YMInitializer
        accounts={[YANDEX_METRICS_ACCOUNT]}
        options={{
          clickmap: true,
          trackLinks: true,
          accurateTrackBounce: true,
          webvisor: true,
          trackHash: true,
          trustedDomains: ["itreit.ru", "reit-invest.ru", "landing.itreit.ru"],
        }}
        version="2"
      />
    ) : (
      <></>
    )}
    <RouterProvider router={router} />
  </React.StrictMode>
);
